module.exports = __webpack_public_path__ + "img/824d3b0a8a4f028b79abd4b1c3c44ad5.46b6f334.png";